import { colors } from '@material-ui/core';

export default {
  root: {
    fontSize: 12,
    backgroundColor: colors.grey[50],
  },
};
